import { PricingSettings } from "@models/PricingRecord";
import React from "react";

type PricingSettingsPageContextValue = {
	pricingSettings: PricingSettings | null;
};

const PricingSettingsPageContext = React.createContext<
	PricingSettingsPageContextValue | undefined
>(undefined);

export function usePricingSettingsPageContext() {
	const context = React.useContext(PricingSettingsPageContext);
	return context ?? { pricingSettings: null };
}

export default PricingSettingsPageContext;
